import React, { useState, useRef } from 'react';
import './GigaProject.css';
import { FaPlay, FaRedo, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';
import GigaProjectImg from '../assets/GigaProject.png';
import videoSrc from '../assets/vidlogo.mp4';

export default function ProjectVideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showReplay, setShowReplay] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
      setShowReplay(false);
    }
  };

  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setIsPlaying(true);
      setShowReplay(false);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
    setShowReplay(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  const handleToggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section className="project-video-section" aria-label="Giga Project video">
      <div className="giga-logo-block">
        <img src={GigaProjectImg} alt="Giga Project" className="giga-logo" />
      </div>

      <div className="giga-player-shell">
        <div className="giga-player-inner">
          <video
            ref={videoRef}
            src={videoSrc}
            className="giga-video"
            muted={isMuted}
            playsInline
            preload="metadata"
            onEnded={handleVideoEnd}
            onPause={handleVideoPause}
          />

          {!isPlaying && !showReplay && (
            <button
              type="button"
              className="giga-overlay giga-overlay--play"
              onClick={handlePlay}
              aria-label="Play video"
            >
              <span className="giga-control-ring" aria-hidden>
                <FaPlay className="giga-control-icon giga-control-icon--play" />
              </span>
              <span className="giga-overlay-hint">Play reel</span>
            </button>
          )}

          {showReplay && (
            <button
              type="button"
              className="giga-overlay giga-overlay--replay"
              onClick={handleReplay}
              aria-label="Replay video"
            >
              <span className="giga-control-ring" aria-hidden>
                <FaRedo className="giga-control-icon" />
              </span>
              <span className="giga-overlay-hint">Watch again</span>
            </button>
          )}

          <div className="giga-audio-wrap">
            <button
              type="button"
              className="giga-audio-btn"
              onClick={handleToggleMute}
              aria-label={isMuted ? 'Unmute video' : 'Mute video'}
              aria-pressed={!isMuted}
            >
              {isMuted ? (
                <FaVolumeMute className="giga-audio-icon" aria-hidden />
              ) : (
                <FaVolumeUp className="giga-audio-icon" aria-hidden />
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
